import axios from './axios'
import api from './api'
const WEB_PATH = {
    // index: 'http://www.baochequan.cn',
    // aboutUs: 'http://www.baochequan.cn/aboutUs.html',
    index: '../index.html',
    aboutUs: '../aboutUs.html'
}
export default {
    install: (Vue, options) => {
        Vue.prototype.$api = api
        Vue.prototype.$ajax = axios
        Vue.prototype.$webPath = WEB_PATH
    }
}